import {Fragment} from "react";
import {useSelector} from "react-redux";

import Header from "./header/Header";
import Footer from "./footer/Footer";
import ErrorLayout from "./ErrorLayout";
import SideMenu from "./sideMenu/SideMenu";
import SphereLoader from "../loaders/SphereLoader";
import AppSphereLoader from "../loaders/AppSphereLoader";


const PageLayout = ({ menu, children, isLoading, isError }) => {
	const component = useSelector(({componentReducer}) => componentReducer);

	return (
		<Fragment>
			{component.appLoader ? <AppSphereLoader/> :
				<div className="page">
					<SideMenu menu={menu}/>
					<Header/>
					<div className="main-content side-content pt-0 jumps-prevent">
						<div className="container-fluid">
							<div className="inner-body">
								{isError ? <ErrorLayout /> : isLoading ? <SphereLoader /> : children}
							</div>
						</div>
					</div>
					<Footer/>
				</div>
			}
		</Fragment>
	)
}

export default PageLayout;
